module.exports = __webpack_public_path__ + "public/media/ic_right_arrow_gray.ab2e74ad.svg";